// import React, { useState } from 'react';
// import logo from '../assets/logo.png';

// const navLinks = [
//   { label: 'Home', href: '/' },
//   { label: 'About us', href: '/About' },
//   { label: 'Contact', href: '/contact' },
// ];

// const serviceLinks = [
//   { label: 'AIS-140 ICAT Certified Devices', href: '/section-1' },
//   { label: 'Consignment Tracking & Management', href: '/section-2' },
//   { label: 'Fuel Automation', href: '/section-3' },
//   { label: 'Construction Fuel Monitoring', href: '/section-4' },
//   { label: 'Fuel Monitoring', href: '/section-5' },
//   { label: 'School Monitoring System', href: '/#solutions' },
//   { label: 'Smart Solid Waste Management Solution', href: '/#solutions' },
//   { label: 'Vehicle Tracking And Fleet Management', href: '/section-9' },
//   { label: 'Video Telematics', href: '/section-10' },
//   { label: 'Cut Fuel Costs by Up to 30%', href: '/fuel-costs' },
// ];

// function Navbar() {
//   const [isServicesOpen, setIsServicesOpen] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
//   const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
//   const isServicesActive =
//     currentPath === '/services' ||
//     serviceLinks.some((service) => service.href === currentPath);

//   const closeMobileMenu = () => {
//     setIsMobileMenuOpen(false);
//     setIsMobileServicesOpen(false);
//   };

//   const linkClassName = (isActive) =>
//     `relative text-sm font-medium transition-colors duration-200 after:absolute after:-bottom-2 after:left-0 after:h-0.5 after:bg-[#e68612] after:transition-all after:duration-200 hover:text-[#e68612] ${
//       isActive
//         ? 'text-[#e68612] after:w-full'
//         : 'text-[#2a201b] after:w-0 hover:after:w-full'
//     }`;

//   return (
//     <header className="absolute left-0 right-0 top-0 z-30 px-3 pt-3 sm:px-5 lg:px-6">
//       <nav className="relative mx-auto flex max-w-[1440px] items-center justify-between gap-3 rounded-xl bg-white px-4 py-2 shadow-lg shadow-black/10 sm:px-5 lg:px-8">
//         <a
//           href="/"
//           aria-label="Veyonta Track home"
//           onClick={closeMobileMenu}
//           className="flex shrink-0 items-center"
//         >
//           <img
//             src={logo}
//             alt="Veyonta Track"
//             className="h-auto w-24 object-contain sm:w-28 lg:w-32"
//           />
//         </a>

//         <div className="hidden items-center gap-7 lg:flex xl:gap-14">
//           <a href="/" className={linkClassName(currentPath === '/')}>
//             Home
//           </a>

//           <div
//             className="relative"
//             onMouseEnter={() => setIsServicesOpen(true)}
//             onMouseLeave={() => setIsServicesOpen(false)}
//             onFocus={() => setIsServicesOpen(true)}
//             onBlur={(event) => {
//               if (!event.currentTarget.contains(event.relatedTarget)) {
//                 setIsServicesOpen(false);
//               }
//             }}
//           >
//             <button
//               type="button"
//               aria-expanded={isServicesOpen}
//               aria-haspopup="true"
//               className={linkClassName(isServicesActive)}
//             >
//               Services
//             </button>

//             {isServicesOpen && (
//               <div className="absolute left-1/2 top-full z-40 w-[min(90vw,420px)] -translate-x-1/2 pt-5">
//                 <div className="max-h-[75vh] overflow-y-auto rounded-lg border border-[#eee4da] bg-white p-3 shadow-2xl">
//                   <div className="grid gap-1">
//                     {serviceLinks.map((service) => (
//                       <a
//                         key={service.label}
//                         href={service.href}
//                         className={`rounded-md px-4 py-3 text-sm font-medium leading-5 transition-colors duration-200 hover:bg-[#f8f0e5] hover:text-[#e68612] ${
//                           currentPath === service.href ? 'bg-[#f8f0e5] text-[#e68612]' : 'text-[#2a201b]'
//                         }`}
//                       >
//                         {service.label}
//                       </a>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>

//           {navLinks.slice(1).map((link) => (
//             <a
//               key={link.href}
//               href={link.href}
//               className={linkClassName(currentPath === link.href)}
//             >
//               {link.label}
//             </a>
//           ))}
//         </div>

//         <a
//           href="/contact"
//           className="hidden h-10 items-center justify-center whitespace-nowrap rounded-md bg-[#e68612] px-5 text-sm font-semibold text-white transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#d97b0f] lg:inline-flex"
//         >
//           Contact us
//         </a>

//         <button
//           type="button"
//           aria-label={isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
//           aria-expanded={isMobileMenuOpen}
//           onClick={() => setIsMobileMenuOpen((isOpen) => !isOpen)}
//           className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-[#f8f0e5] text-[#2a201b] transition-colors hover:bg-[#f1dfc7] lg:hidden"
//         >
//           {isMobileMenuOpen ? (
//             <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2">
//               <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
//             </svg>
//           ) : (
//             <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2">
//               <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" />
//             </svg>
//           )}
//         </button>

//         {isMobileMenuOpen && (
//           <div className="absolute left-0 right-0 top-[calc(100%+0.75rem)] overflow-hidden rounded-lg border border-[#eee4da] bg-white p-3 shadow-2xl lg:hidden">
//             <div className="flex flex-col gap-1">
//               <a
//                 href="/"
//                 onClick={closeMobileMenu}
//                 className={`rounded-md px-4 py-3 text-sm font-medium transition-colors hover:bg-[#f8f0e5] hover:text-[#e68612] ${
//                   currentPath === '/' ? 'bg-[#f8f0e5] text-[#e68612]' : 'text-[#2a201b]'
//                 }`}
//               >
//                 Home
//               </a>

//               <button
//                 type="button"
//                 aria-expanded={isMobileServicesOpen}
//                 onClick={() => setIsMobileServicesOpen((isOpen) => !isOpen)}
//                 className={`flex w-full items-center justify-between rounded-md px-4 py-3 text-left text-sm font-medium transition-colors hover:bg-[#f8f0e5] hover:text-[#e68612] ${
//                   isServicesActive ? 'text-[#e68612]' : 'text-[#2a201b]'
//                 }`}
//               >
//                 Services
//                 <svg
//                   viewBox="0 0 24 24"
//                   className={`h-4 w-4 transition-transform ${isMobileServicesOpen ? 'rotate-180' : ''}`}
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
//                 </svg>
//               </button>

//               {isMobileServicesOpen && (
//                 <div className="max-h-[45vh] overflow-y-auto rounded-md bg-[#fcf8f3] p-2">
//                   {serviceLinks.map((service) => (
//                     <a
//                       key={`${service.label}-mobile`}
//                       href={service.href}
//                       onClick={closeMobileMenu}
//                       className={`block rounded px-3 py-2.5 text-xs font-medium leading-5 transition-colors hover:bg-white hover:text-[#e68612] ${
//                         currentPath === service.href ? 'bg-white text-[#e68612]' : 'text-[#2a201b]'
//                       }`}
//                     >
//                       {service.label}
//                     </a>
//                   ))}
//                 </div>
//               )}

//               {navLinks.slice(1).map((link) => (
//                 <a
//                   key={`${link.href}-mobile`}
//                   href={link.href}
//                   onClick={closeMobileMenu}
//                   className={`rounded-md px-4 py-3 text-sm font-medium transition-colors hover:bg-[#f8f0e5] hover:text-[#e68612] ${
//                     currentPath === link.href ? 'bg-[#f8f0e5] text-[#e68612]' : 'text-[#2a201b]'
//                   }`}
//                 >
//                   {link.label}
//                 </a>
//               ))}

//               <a
//                 href="/contact"
//                 onClick={closeMobileMenu}
//                 className="mt-2 inline-flex h-11 items-center justify-center rounded-md bg-[#e68612] px-5 text-sm font-semibold text-white transition-colors hover:bg-[#d97b0f]"
//               >
//                 Contact us
//               </a>
//             </div>
//           </div>
//         )}
//       </nav>
//     </header>
//   );
// }

// export default Navbar;




import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/VEYONTA LOGO.pdf.png';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'About us', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

const serviceLinks = [
  { label: 'AIS-140 ICAT Certified Devices', href: '/section-1' },
  { label: 'Consignment Tracking & Management', href: '/section-2' },
  { label: 'Fuel Automation', href: '/section-3' },
  { label: 'Construction Fuel Monitoring', href: '/section-4' },
  { label: 'Fuel Monitoring', href: '/section-5' },
  { label: 'School Monitoring System', href: '/section-6' },
  { label: 'Smart Solid Waste Management Solution', href: '/section-7' },
  { label: 'Vehicle Tracking And Fleet Management', href: '/section-9' },
  { label: 'Video Telematics', href: '/section-10' },
  // { label: 'Cut Fuel Costs by Up to 30%', href: '/fuel-costs' },
];

function Navbar() {
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
  const { pathname } = useLocation();
  const currentPath = pathname.replace(/\/$/, '') || '/';
  const isServicesActive =
    currentPath === '/services' ||
    serviceLinks.some((service) => service.href === currentPath);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsMobileServicesOpen(false);
  };

  const linkClassName = (isActive) =>
    `relative text-sm font-medium transition-colors duration-200 after:absolute after:-bottom-2 after:left-0 after:h-0.5 after:bg-[#e68612] after:transition-all after:duration-200 hover:text-[#e68612] ${
      isActive
        ? 'text-[#e68612] after:w-full'
        : 'text-[#2a201b] after:w-0 hover:after:w-full'
    }`;

  return (
    <header className="absolute left-0 right-0 top-0 z-30 px-3 pt-3 sm:px-5 lg:px-6">
      <nav className="relative mx-auto flex max-w-[1440px] items-center justify-between gap-3 rounded-xl bg-white px-4 py-2 shadow-lg shadow-black/10 sm:px-5 lg:px-8">
        <Link
          to="/"
          aria-label="Veyonta Track home"
          onClick={closeMobileMenu}
          className="flex shrink-0 items-center"
        >
          <img
            src={logo}
            alt="Veyonta Track"
            className="h-auto w-24 object-contain sm:w-28 lg:w-32"
          />
        </Link>

        <div className="hidden items-center gap-7 lg:flex xl:gap-14">
          <Link to="/" className={linkClassName(currentPath === '/')}>
            Home
          </Link>

          <div
            className="relative"
            onMouseEnter={() => setIsServicesOpen(true)}
            onMouseLeave={() => setIsServicesOpen(false)}
            onFocus={() => setIsServicesOpen(true)}
            onBlur={(event) => {
              if (!event.currentTarget.contains(event.relatedTarget)) {
                setIsServicesOpen(false);
              }
            }}
          >
            <button
              type="button"
              aria-expanded={isServicesOpen}
              aria-haspopup="true"
              className={linkClassName(isServicesActive)}
            >
              Services
            </button>

            {isServicesOpen && (
              <div className="absolute left-1/2 top-full z-40 w-[min(90vw,760px)] -translate-x-1/2 pt-5">
                <div className="max-h-[75vh] overflow-y-auto rounded-lg border border-[#eee4da] bg-white p-3 shadow-2xl">
                  <div className="grid grid-flow-col grid-rows-5 gap-1">
                    {serviceLinks.map((service) => (
                      <Link
                        key={service.label}
                        to={service.href}
                        onClick={() => setIsServicesOpen(false)}
                        className={`rounded-md px-4 py-3 text-sm font-medium leading-5 transition-colors duration-200 hover:bg-[#f8f0e5] hover:text-[#e68612] ${
                          currentPath === service.href ? 'bg-[#f8f0e5] text-[#e68612]' : 'text-[#2a201b]'
                        }`}
                      >
                        {service.label}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>

          {navLinks.slice(1).map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={linkClassName(currentPath === link.href)}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <Link
          to="/contact"
          className="hidden h-10 items-center justify-center whitespace-nowrap rounded-md bg-[#e68612] px-5 text-sm font-semibold text-white transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#d97b0f] lg:inline-flex"
        >
          Contact us
        </Link>

        <button
          type="button"
          aria-label={isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={isMobileMenuOpen}
          onClick={() => setIsMobileMenuOpen((isOpen) => !isOpen)}
          className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-[#f8f0e5] text-[#2a201b] transition-colors hover:bg-[#f1dfc7] lg:hidden"
        >
          {isMobileMenuOpen ? (
            <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" />
            </svg>
          )}
        </button>

        {isMobileMenuOpen && (
          <div className="absolute left-0 right-0 top-[calc(100%+0.75rem)] overflow-hidden rounded-lg border border-[#eee4da] bg-white p-3 shadow-2xl lg:hidden">
            <div className="flex flex-col gap-1">
              <Link
                to="/"
                onClick={closeMobileMenu}
                className={`rounded-md px-4 py-3 text-sm font-medium transition-colors hover:bg-[#f8f0e5] hover:text-[#e68612] ${
                  currentPath === '/' ? 'bg-[#f8f0e5] text-[#e68612]' : 'text-[#2a201b]'
                }`}
              >
                Home
              </Link>

              <button
                type="button"
                aria-expanded={isMobileServicesOpen}
                onClick={() => setIsMobileServicesOpen((isOpen) => !isOpen)}
                className={`flex w-full items-center justify-between rounded-md px-4 py-3 text-left text-sm font-medium transition-colors hover:bg-[#f8f0e5] hover:text-[#e68612] ${
                  isServicesActive ? 'text-[#e68612]' : 'text-[#2a201b]'
                }`}
              >
                Services
                <svg
                  viewBox="0 0 24 24"
                  className={`h-4 w-4 transition-transform ${isMobileServicesOpen ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              {isMobileServicesOpen && (
                <div className="max-h-[45vh] overflow-y-auto rounded-md bg-[#fcf8f3] p-2">
                  {serviceLinks.map((service) => (
                    <Link
                      key={`${service.label}-mobile`}
                      to={service.href}
                      onClick={closeMobileMenu}
                      className={`block rounded px-3 py-2.5 text-xs font-medium leading-5 transition-colors hover:bg-white hover:text-[#e68612] ${
                        currentPath === service.href ? 'bg-white text-[#e68612]' : 'text-[#2a201b]'
                      }`}
                    >
                      {service.label}
                    </Link>
                  ))}
                </div>
              )}

              {navLinks.slice(1).map((link) => (
                <Link
                  key={`${link.href}-mobile`}
                  to={link.href}
                  onClick={closeMobileMenu}
                  className={`rounded-md px-4 py-3 text-sm font-medium transition-colors hover:bg-[#f8f0e5] hover:text-[#e68612] ${
                    currentPath === link.href ? 'bg-[#f8f0e5] text-[#e68612]' : 'text-[#2a201b]'
                  }`}
                >
                  {link.label}
                </Link>
              ))}

              <Link
                to="/contact"
                onClick={closeMobileMenu}
                className="mt-2 inline-flex h-11 items-center justify-center rounded-md bg-[#e68612] px-5 text-sm font-semibold text-white transition-colors hover:bg-[#d97b0f]"
              >
                Contact us
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}

export default Navbar;

